import Vue from 'vue';
import BaseIcon from './base-icon'

import Trash from 'shared/assets/icons/trash.svg';
import VR from 'shared/assets/icons/vr.svg';
import Menu from 'shared/assets/icons/menu.svg';
import Home from 'shared/assets/icons/home.svg';
import visibilityIcon from 'shared/assets/icons/visibility.svg';
import MultipleFilesIcon from 'shared/assets/icons/multipleFiles.svg';

import VideoSVG from 'shared/assets/icons/video.svg';
import StopSVG from 'shared/assets/icons/stop.svg';
import QuestionSVG from 'shared/assets/icons/question.svg';
import PlaySVG from 'shared/assets/icons/play.svg';
import PauseSVG from 'shared/assets/icons/pause.svg';
import forwardSvg from 'shared/assets/icons/forward.svg';
import InfoSVG from 'shared/assets/icons/info.svg';
import ImageSVG from 'shared/assets/icons/image.svg';
import BackSVG from 'shared/assets/icons/back.svg';
import Back2SVG from 'shared/assets/icons/back2.svg';
import SettingsSVG from 'shared/assets/icons/settings.svg';
import Menu2SVG from 'shared/assets/icons/menu2.svg';
import ResetSVG from 'shared/assets/icons/reset.svg';
import AudioSVG from 'shared/assets/icons/audio.svg';
import CloseSVG from 'shared/assets/icons/close.svg';
import UpperCaseA from 'shared/assets/icons/upperCaseA.svg';
import UpperCaseB from 'shared/assets/icons/upperCaseB.svg';
import UpperCaseC from 'shared/assets/icons/upperCaseC.svg';
import UpperCaseD from 'shared/assets/icons/upperCaseD.svg';
import UpperCaseE from 'shared/assets/icons/upperCaseE.svg';
import UpperCaseF from 'shared/assets/icons/upperCaseF.svg';
import UpperCaseT from 'shared/assets/icons/upperCaseT.svg';
import Number1 from 'shared/assets/icons/number1.svg';
import Number2 from 'shared/assets/icons/number2.svg';
import Number3 from 'shared/assets/icons/number3.svg';
import Number4 from 'shared/assets/icons/number4.svg';
import Number5 from 'shared/assets/icons/number5.svg';

import OverviewListSVG from 'shared/assets/icons/OverviewList.svg';
import InformationInstructionSVG from 'shared/assets/icons/InformationInstruction.svg';
import MaintenanceAssemblySVG from 'shared/assets/icons/MaintenanceAssembly.svg';
import ToolsSVG from 'shared/assets/icons/Tools.svg';
import InstructionsWorkflowSVG from 'shared/assets/icons/InstructionsWorkflow.svg';
import QuizSVG from 'shared/assets/icons/Quiz.svg';
import EvaluationSVG from 'shared/assets/icons/Evaluation.svg';
import DangerSVG from 'shared/assets/icons/Danger.svg';
import SafetySVG from 'shared/assets/icons/Safety.svg';
import SearchSVG from 'shared/assets/icons/Search.svg';

function generateIconComponent(name, icon) {

    return Vue.component(name, {
        extends: BaseIcon,
        components: {
            Icon: icon
        }
    })
}

export default {
    home: generateIconComponent('home-icon', Home),
    menu: generateIconComponent('menu-icon', Menu),
    trash: generateIconComponent('trash-icon', Trash),
    vr: generateIconComponent('vr-icon', VR),
    visibility: generateIconComponent('visibility-icon', visibilityIcon),
    multipleFiles: generateIconComponent('multiple-files-icon', MultipleFilesIcon),
    video: generateIconComponent('video-icon', VideoSVG),
    stop: generateIconComponent('stop-icon', StopSVG),
    question: generateIconComponent('question-icon', QuestionSVG),
    play: generateIconComponent('play-icon', PlaySVG),
    pause: generateIconComponent('pause-icon', PauseSVG),
    forward: generateIconComponent('forward-icon', forwardSvg),
    info: generateIconComponent('info-icon', InfoSVG),
    image: generateIconComponent('image-icon', ImageSVG),
    back: generateIconComponent('back-icon', BackSVG),
    back2: generateIconComponent('back2-icon', Back2SVG),
    settings: generateIconComponent('settings-icon', SettingsSVG),
    menu2: generateIconComponent('menu2-icon', Menu2SVG),
    reset: generateIconComponent('reset-icon', ResetSVG),
    audio: generateIconComponent('audio-icon', AudioSVG),
    close: generateIconComponent('close-icon', CloseSVG),
    upperCaseA: generateIconComponent('upperCaseA-icon', UpperCaseA),
    upperCaseB: generateIconComponent('upperCaseB-icon', UpperCaseB),
    upperCaseC: generateIconComponent('upperCaseC-icon', UpperCaseC),
    upperCaseD: generateIconComponent('upperCaseD-icon', UpperCaseD),
    upperCaseE: generateIconComponent('upperCaseE-icon', UpperCaseE),
    upperCaseF: generateIconComponent('upperCaseF-icon', UpperCaseF),
    upperCaseT: generateIconComponent('upperCaseT-icon', UpperCaseT),
    number1: generateIconComponent('numberOne-icon', Number1),
    number2: generateIconComponent('numberTwo-icon', Number2),
    number3: generateIconComponent('numberThree-icon', Number3),
    number4: generateIconComponent('numberFour-icon', Number4),
    number5: generateIconComponent('numberFive-icon', Number5),
    overviewList: generateIconComponent('overview-list-icon', OverviewListSVG),
    informationInstruction: generateIconComponent('information-instruction-icon', InformationInstructionSVG),
    maintenanceAssembly: generateIconComponent('maintenance-assembly-icon', MaintenanceAssemblySVG),
    tools: generateIconComponent('tools-icon', ToolsSVG),
    instructionsWorkflow: generateIconComponent('instructions-workflow-icon', InstructionsWorkflowSVG),
    quiz: generateIconComponent('quiz-icon', QuizSVG),
    evaluation: generateIconComponent('evaluation-icon', EvaluationSVG),
    danger: generateIconComponent('danger-icon', DangerSVG),
    safety: generateIconComponent('safety-icon', SafetySVG),
    search: generateIconComponent('search-icon', SearchSVG),
}

